import img from '../assets/banner.jpg';

export const Header = () => {

    return (
        <div className="relative px-4 pt-16 mx-auto lg:py-32 md:px-8 xl:px-20 sm:max-w-xl md:max-w-full">
            <div className="max-w-xl mx-auto lg:max-w-screen-xl">
                <div className="mb-16 lg:max-w-lg lg:mb-0">
                    <div className="max-w-xl mb-6">
                        <div>
                            <p className="inline-block px-3 py-px mb-4 text-xs font-semibold tracking-wider text-teal-900 uppercase rounded-full bg-teal-accent-400">
                                Quiz! Quiz
                            </p>
                        </div>
                        <h2 className='text-3xl my-4 font-bold'>
                            Welcome
                            in This Quiz Mania.
                        </h2>
                        <p className="text-base text-gray-700 md:text-lg">
                            Hello good people. You are very very welcome in this quiz mania. If you searching for judge your knowledge about programming, then you are in right place.
                        </p>
                    </div>

                </div>
            </div>
            <div className="flex justify-center h-full overflow-hidden lg:w-2/3 xl:w-1/2 lg:absolute lg:justify-start lg:bottom-0 lg:right-0 ">
                <img
                    src={img}
                    className="object-cover object-top w-full h-64 max-w-xl -mb-16 rounded shadow-2xl lg:ml-64 xl:ml-8 lg:-mb-24 xl:-mb-28 lg:h-auto lg:max-w-screen-md"
                    alt=""
                />
            </div>
        </div>
    );
};